import { render } from "./ContentPlaceholderComponent.vue?vue&type=template&id=45246219&scoped=true"
import script from "./ContentPlaceholderComponent.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholderComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45246219"]])

export default __exports__